var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-9" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.uniqueTemplates, function(template) {
            return _c(
              "div",
              { key: template.id, staticClass: "col-6" },
              [_c("scenario-template-item", { attrs: { id: template.id } })],
              1
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-10" },
            [
              _c("change-info", {
                on: {
                  "trigger-change-info": function($event) {
                    return _vm.$emit("trigger-change-info")
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mr-3" }, [
      _c("div", { staticClass: "col-12 mb-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary pull-right btn-lg",
            on: { click: _vm.accept }
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.resource("DmVisualizer_Accept_Data_Button_Text")) +
                "\n            "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }